import React from "react";
import { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Dishes from "../components/Home/Dishes";
import SaleItems from "../components/Home/SaleItems";
import Slideshow from "../components/Home/Slideshow";
import TopSelling from "../components/Home/TopSelling";

const Home = () => {
  const navigate = useNavigate();
  const [category, setCategory] = useState("THAT MATTERS");
  const data = useSelector((state) => state.cartDetail);
  const user = useSelector((state) => state.adminDetail);
  return (
    <div className="home_container ">
      <div className="showcase_container">
        <div className="column1">
          <span className="head">2022 AMY STORE</span>

          <h2 className="body">STORE THAT SELLS </h2>
          <h2 className="highlight">{category}</h2>
          {!user.userId && (
            <button onClick={() => navigate("/login")} className="foot">
              Login{" "}
            </button>
          )}
        </div>

        <Slideshow setCategory={setCategory} />
      </div>

      <div className="product_showed_container">
        <Dishes />
        <SaleItems />
        <TopSelling />
      </div>
    </div>
  );
};

export default Home;
